import React from 'react';
import { PapiGallection } from '@wix/da-types-papi';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import OnScrollBottom, {
  DISTANCE_UNIT,
} from '@wix/da-shared-react/pkg/OnScrollBottom';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import FolderContentList from '../FolderContentList';
import FolderBarFolderDropdown from '../FolderBar/_partials/FolderBarFolderDropdown';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile';

import profilesCssVars from '../../../../styles/variables.scss';
import s from './GallectionsListView.scss';

export interface Props {
  distanceToRender: number;
  currentFolder?: PapiGallection;
  onScrollToFolder: (folderId: number) => void;
  onScrolledToBottom: () => void;
}

const MobileGallectionsListView: React.FC<Props> = ({
  distanceToRender,
  onScrollToFolder,
  onScrolledToBottom,
  currentFolder,
}) => {
  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <WidgetHeaderMobile
          isSticky={false}
          rootClassName={s['widget-header-mobile']}
          header={false}
          extras={
            <FolderBarFolderDropdown
              offsetTop={parseInt(profilesCssVars['mobile-navbar-height']) - 1}
              currentFolder={currentFolder}
              arrowIconSize={IconSize.MEDIUM}
            />
          }
        />
        <div id="sub-folder-gallery">
          <FolderContentList onScrollToFolder={onScrollToFolder} />
          <OnScrollBottom
            distanceToBottom={distanceToRender}
            distanceUnit={DISTANCE_UNIT.WINDOW_HEIGHT}
            onScrolledToBottom={onScrolledToBottom}
          />
        </div>
      </ErrorBoundary>
    </div>
  );
};
MobileGallectionsListView.displayName = 'MobileGallectionsListView';

export default MobileGallectionsListView;
